import React from "react";
import { AiFillGithub, AiFillLinkedin, AiOutlineGift } from "react-icons/ai";
import { GenIcon } from "react-icons/lib";
import Typed from "react-typed";

export default function main() {
  return (
    <div className=" bg-[greenyellow] h-[auto] p-5 md:p-8" id="span">
      <div className=" bg-[#000000c7] h-[auto] text-[white] max-w-[1150px] mx-auto rounded-3xl ">
        {/* header---------- */}
        <div className=" flex justify-between h-[auto] p-4 items-center max-w-[1100px] mx-auto">
          <div className=" font-bold text-[18px] md:text-[30px]">
            <a href="index.html">
              Shiv<span>Raj</span>
            </a>
          </div>
          <div>
            <ul className="hidden md:flex flex-row gap-2 md:gap-8 ">
              <li className=" hover:text-[greenyellow] hover:scale-105 font-bold">
                <a href="index.html">Home</a>
              </li>
              <li className=" hover:text-[greenyellow]  hover:scale-105 font-bold">
                <a href="https://ubiquitous-cannoli-b2fc15.netlify.app/work.html">
                  My Work
                </a>
              </li>
              <li className=" hover:text-[greenyellow] hover:scale-105 font-bold">
                <a href="https://drive.google.com/file/d/1SWG13dcD5Xl2I9o84oUD7egFyIRjc7OE/view?usp=sharing">
                  Resume
                </a>
              </li>
              <li className=" hover:text-[greenyellow] hover:scale-105 font-bold">
                <a href="https://wa.me/+918920557494">Contact</a>
              </li>
            </ul>
          </div>
        </div>

        {/* banner1----------- */}

        <div className=" md:grid grid-cols-2 justify-between  max-w-[1100px] mx-auto">
          <div className=" p-3">
            <img
              className=" rounded-r-3xl shadow-r-2xl  shadow-[greenyellow]"
              src="https://thumbs.dreamstime.com/b/blue-calm-gaming-setup-210714070.jpg"
            ></img>
          </div>

          <div className=" flex flex-col items-center my-8  p-5">
            <h1 className=" font-[extrabold] text-[15px] md:text-[30px]">
              <span>✄</span>Code<span>✄</span>I Have{" "}
              <Typed
                strings={[
                  "Curiosity",
                  "Teamwork Skill",
                  "Perseverance ",
                  "Attention to detail",

                  "Creativit Skill",
                ]}
                typeSpeed={40}
                backSpeed={50}
                loop
              ></Typed>
            </h1>

            <h1 className=" inline-flex justify-center items-center gap-4 font-[bold] text-[20px] md:text-[30px]">
              ShivRaj Singh
              <span className=" inline-flex justify-center items-center gap-5 text-[30px]">
                <a href="https://github.com/shivamkumarsha">
                  <AiFillGithub />
                </a>

                <a href="https://www.linkedin.com/in/shivraj-signh-7bb9411b9/">
                  <AiFillLinkedin />
                </a>
              </span>
            </h1>
            <h1 className=" font-thin text-[15px] md:text-[20px] my-8">
              I'm a India based Full Stack Web. Developer, currently working at
              REACT.JS Talwind css full responsive Website with seo conatant and
              helping build a modern, mobile-first, domain registrar and site
              builder. In my free time time, you can catch me training in Delhi,
              R.C.M Swiming Center , or exploring beautiful Delhi Cafe's.
            </h1>
          </div>
        </div>

        {/* banner2---------- */}
        <div className=" my-8">
          <div className="font-bold text-[30px] border-b ">
            <h1>
              Abo<span>ut Me</span>
            </h1>
          </div>

          <div className="md:flex flex-row items-center p-5">
            <div className=" my-8 w-[100%] md:w-[50%] m-5 mx-auto">
              <h1 className=" font-thin text-[20px]">
                I am an athlete at heart with an entrepreneurial spirit, a knack
                for online security, and a passion for coding. Born in a small
                town in Inida- Delhi, I work as a front-end developer for
                Instant Domains, alongside my many ongoing projects. Outside of
                work I am an avid motorcyclist, soccer player and Muay Thai
                fighter. I love to travel and lead a fairly nomadic lifestyle. I
                built much of my early portfolio from beaches of Southeast Inida
                and dream of taking my work with me while traveling the world.
              </h1>
              <div className="flex flex-row my-8 font-bold  w-[100%] mx-auto justify-center gap-14">
                <div className="flex flex-col justify-center">
                  <h1>
                    <span>✫</span>Location: Inida Delhi
                  </h1>
                  <h1>
                    <span>Ɖ</span>Study: University of CSE
                  </h1>
                  <h1>
                    <span>⌘</span>Nationality: indian/Hindu
                  </h1>
                </div>

                <div className="flex flex-col  justify-center">
                  <h1>
                    <span>✫</span>Age: 18
                  </h1>
                  <h1>
                    <span>Ɖ</span>Interests: Hacking, Motorcycling, Solo Tour
                  </h1>
                  <h1>
                    <span>⌘</span>Employment: Freelancer
                  </h1>
                </div>
              </div>
            </div>

            <div className="p-5">
              <div className=" p-4 rounded-2xl" id="shadebox">
                <img
                  className=" rounded-t-full h-[50%] md:h-[80vh]"
                  src="https://ubiquitous-cannoli-b2fc15.netlify.app/img/mine.png"
                ></img>
              </div>
            </div>
          </div>
        </div>

        {/* banner-3---- */}

        <div className=" flex flex-col">
          <div className=" font-bold text-[40px] border-b-2">
            <h1>
              St<span>ats</span>
            </h1>
          </div>

          <div className=" md:flex flex-row justify-around  p-5">
            <div className=" flex font-bold bg-[#ffffff41] my-5 shadow-2xl rounded-3xl text-[30px] flex-col justify-center items-center p-5">
              <AiFillGithub />
              <h1>
                <span>Git Stare</span>
              </h1>
              <h1 className=" font-bold text-[30px]">1089</h1>
            </div>

            <div className=" flex font-bold bg-[#ffffff41] my-5 shadow-2xl rounded-3xl text-[30px] flex-col justify-center items-center p-5">
              <AiFillGithub />
              <h1>
                <span>H-Tron</span>
              </h1>
              <h1 className=" font-bold text-[30px]">2453</h1>
            </div>

            <div className=" flex font-bold bg-[#ffffff41] my-5 shadow-2xl rounded-3xl text-[30px] flex-col justify-center items-center p-5">
              <AiFillGithub />
              <h1>
                <span>Hunger</span>
              </h1>
              <h1 className=" font-bold text-[30px]">1989</h1>
            </div>

            <div className=" flex font-bold bg-[#ffffff41] my-5 shadow-2xl rounded-3xl text-[30px] flex-col justify-center items-center p-5">
              <AiFillGithub />
              <h1>
                <span>Deep-C</span>
              </h1>
              <h1 className=" font-bold text-[30px]">2349</h1>
            </div>

            <div className=" flex font-bold bg-[#ffffff41] my-5 shadow-2xl rounded-3xl text-[30px] flex-col justify-center items-center p-5">
              <AiFillGithub />
              <h1>
                <span>C-Bit</span>
              </h1>
              <h1 className=" font-bold text-[30px]">2089</h1>
            </div>
          </div>
        </div>

        {/* banner----4-------- */}

        <div className=" p-5 my-10 rounded-3xl">
          <div className=" my-10 font-bold text-[30px] border-b">
            <h1>
              <span>My</span> Work
            </h1>
          </div>

          <div className=" md:flex my-10 flex-row justify-around">
            <div className=" w-[100%] my-5 md:w-[30%] hover:scale-105 ease-in-out duration-300 ">
              <a href="https://starlit-jalebi-5ec670.netlify.app/">
                <img
                  className="rounded-3xl"
                  src="https://ubiquitous-cannoli-b2fc15.netlify.app/img/project%201.png"
                ></img>

                <h1 className=" font-bold text-[20px]">Game Website</h1>
              </a>
            </div>

            <AiOutlineGift className="hidden md:flex" />

            <div className=" w-[100%] my-5 md:w-[30%] ease-in-out hover:scale-105 duration-300">
              <a href="https://loquacious-pie-15277d.netlify.app/">
                <img
                  className="rounded-3xl"
                  src="https://ubiquitous-cannoli-b2fc15.netlify.app/img/project%202.png"
                ></img>
              </a>
              <h1 className=" font-bold text-[20px]">Portfolio</h1>
            </div>

            <AiOutlineGift className="hidden md:flex" />
            <div className=" w-[100%] my-5 md:w-[30%] hover:scale-105 ease-in-out duration-300">
              <a href="index.html">
                <img
                  className="rounded-3xl"
                  src="https://ubiquitous-cannoli-b2fc15.netlify.app/img/project%203.png"
                ></img>
                <h1 className=" font-bold text-[20px]">Burger King</h1>
              </a>
            </div>
          </div>
        </div>

        {/* banner---5----- */}

        <div className="md:flex flex-row">
          <div className="md:flex flex-row">
            <div className=" border-[greenyellow] flex font-bold text-[26px]  justify-center items-center p-5">
              <h1>
                Edu<span>cation</span>
              </h1>
            </div>

            <div className="flex  flex-col p-3">
              <div className="flex border-l-2 p- border-[greenyellow] border-b-2 rounded-x flex-col p-3 w-[100%]">
                <h1 className=" p-3 border-[greenyellow] h-[auto] border rounded-2xl bg-[#00000050] ">
                  2019 - 2022
                </h1>

                <span>University of Victoria</span>
                <h1>Bachelor of Computer Science</h1>
                <h1>
                  Under the recommendation and Guidance of the Head Coach of the
                  UVIC soccer team, I transferred to the University of Victoria.
                  Here I took my Bachelors of Computer Science with a Software
                  Engineering Specialty and achieved a much more thorough
                  education in the underlying theory, concepts, and science
                  behind more complex programming. It was here that I discovered
                  my passion for scalable application programming (web and
                  mobile), the security behind computer and application systems,
                  and found that I have a knack for understanding complex
                  algorithms.
                </h1>
              </div>

              <div className="flex border-r-2 p-5 border-[greenyellow] border-b-2 rounded-x flex-col p-3 w-[10`0%]">
                <h1 className=" p-3 border-[greenyellow] border rounded-2xl bg-[#00000050] ">
                  2022 - 2025
                </h1>

                <span>BCA</span>
                <h1>Bachelor IN Computer Application</h1>
                <h1>
                  Under the recommendation and Guidance of the Head Coach of the
                  UVIC soccer team, I transferred to the University of Victoria.
                  Here I took my Bachelors of Computer Science with a Software
                  Engineering Specialty and achieved a much more thorough
                  education in the underlying theory, concepts, and science
                  behind more complex programming. It was here that I discovered
                  my passion for scalable application programming (web and
                  mobile), the security behind computer and application systems,
                  and found that I have a knack for understanding complex
                  algorithms.
                </h1>
              </div>
            </div>
          </div>

          <div className="md:flex flex-row">
            <div className=" border-[greenyellow] flex font-bold text-[26px]  justify-center items-center p-5">
              <h1>
                Expe
                <span>rience</span>
              </h1>
            </div>

            <div className="flex  flex-col p-3">
              <div className="flex border-l-2 p- border-[greenyellow] border-b-2 rounded-x flex-col p-3 w-[100%]">
                <h1 className=" p-3 border-[greenyellow] h-[auto] border rounded-2xl bg-[#00000050] ">
                2022 - Till
                </h1>

                <span>Freelancer</span>
                <h1>Front End Developer</h1>
                <h1>
                I am currently working as a Front End Developer at Instant Domains, Inc. We are a Y-Combinator backed startup building a modern, mobile-first domain registrar and site builder. Here I'm responsible for building the core technologies and features to allow our users to find and buy a domain, launch a fully configured site, and begin collecting revenue with less effort than creating a social media profile.
                </h1>
              </div>

              <div className="flex border-r-2 p-5 border-[greenyellow] border-b-2 rounded-x flex-col p-3 w-[100%]">
                <h1 className=" p-3 border-[greenyellow] border rounded-2xl bg-[#00000050] ">
                  2022 - Till
                </h1>

                <span>Freelancer</span>
                <h1>Website Developer</h1>
                <h1>
                I am currently working as a Software Engineer at Instant Domains, Inc. We are a Y-Combinator backed startup building a modern, mobile-first domain registrar and site builder. Here I'm responsible for building the core technologies and features to allow our users to find and buy a domain, launch a fully configured site, and begin collecting revenue with less effort than creating a social media profile.
                </h1>
              </div>
            </div>
          </div>
        </div>
        

        <div className="flex-row flex bg-[black] p-5 justify-between">
          <div>
            <h1>&copy;2023 ShivRaj Singh</h1>
          </div>

          <div>
          <span className=" inline-flex hover:scale-105 justify-center items-center gap-5 text-[30px]">
                <a href="https://github.com/shivamkumarsha">
                  <AiFillGithub />
                </a>

                <a href="https://www.linkedin.com/in/shivraj-signh-7bb9411b9/">
                  <AiFillLinkedin />
                </a>
              </span>
          </div>

        </div>


      </div>
    </div>
  );
}
